/**
 * Fiskal Cloud Admin ELSTER Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AdminElsterContractBodyDTO } from '../model/models';
import { ContractLogPeriodEnumDTO } from '../model/models';
import { ContractStatusEnumDTO } from '../model/models';
import { ElsterContractCreateBodyDTO } from '../model/models';
import { ElsterContractDTO } from '../model/models';
import { ElsterContractStatusChangeDTO } from '../model/models';
import { ElsterContractsResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateElsterContractRequestParams {
    elsterContractCreateBodyDTO: ElsterContractCreateBodyDTO;
}

export class ClsCreateElsterContractRequestParams {
    elsterContractCreateBodyDTO: ElsterContractCreateBodyDTO = undefined;
}

export interface DeleteElsterContractRequestParams {
    elsterContractId: string;
}

export class ClsDeleteElsterContractRequestParams {
    elsterContractId: string = undefined;
}

export interface GetElsterContractByIdRequestParams {
    elsterContractId: string;
}

export class ClsGetElsterContractByIdRequestParams {
    elsterContractId: string = undefined;
}

export interface GetElsterContractsRequestParams {
    contractLogPeriod?: Array<ContractLogPeriodEnumDTO>;
    projectNumber?: string;
    filter?: string;
    search?: string;
    status?: Array<ContractStatusEnumDTO>;
    contractMonth?: string;
    customerName?: string;
    customerIdentifier?: string;
    contractIds?: Array<string>;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetElsterContractsRequestParams {
    contractLogPeriod?: Array<ContractLogPeriodEnumDTO> = undefined;
    projectNumber?: string = undefined;
    filter?: string = undefined;
    search?: string = undefined;
    status?: Array<ContractStatusEnumDTO> = undefined;
    contractMonth?: string = undefined;
    customerName?: string = undefined;
    customerIdentifier?: string = undefined;
    contractIds?: Array<string> = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface UpdateElsterContractRequestParams {
    elsterContractId: string;
    ifMatch: string;
    adminElsterContractBodyDTO: AdminElsterContractBodyDTO;
}

export class ClsUpdateElsterContractRequestParams {
    elsterContractId: string = undefined;
    ifMatch: string = undefined;
    adminElsterContractBodyDTO: AdminElsterContractBodyDTO = undefined;
}

export interface UpdateElsterContractStatusRequestParams {
    elsterContractId: string;
    ifMatch: string;
    elsterContractStatusChangeDTO: ElsterContractStatusChangeDTO;
}

export class ClsUpdateElsterContractStatusRequestParams {
    elsterContractId: string = undefined;
    ifMatch: string = undefined;
    elsterContractStatusChangeDTO: ElsterContractStatusChangeDTO = undefined;
}


export interface AdminContractsApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a new elster contract
     * Create a new elster contract
* @param requestParameters
     */
    createElsterContract(requestParameters: CreateElsterContractRequestParams, extraHttpRequestParams?: any): Observable<ElsterContractDTO>;

    /**
     * Delete an elster contract
     * Delete an existing elster contract.
* @param requestParameters
     */
    deleteElsterContract(requestParameters: DeleteElsterContractRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get an elster contract detail
     * Get an elster contract detail for the specified UUID.
* @param requestParameters
     */
    getElsterContractById(requestParameters: GetElsterContractByIdRequestParams, extraHttpRequestParams?: any): Observable<ElsterContractDTO>;

    /**
     * Get all elster contracts
     * Get all elster contracts or filter by specified criteria.
* @param requestParameters
     */
    getElsterContracts(requestParameters: GetElsterContractsRequestParams, extraHttpRequestParams?: any): Observable<ElsterContractsResponseDTO>;

    /**
     * Update an elster contract
     * Update an elster contract information. It\&#39;s possible to set a date when the change takes effect.
* @param requestParameters
     */
    updateElsterContract(requestParameters: UpdateElsterContractRequestParams, extraHttpRequestParams?: any): Observable<ElsterContractDTO>;

    /**
     * Update an elster contract status
     * Update an elster contract status.
* @param requestParameters
     */
    updateElsterContractStatus(requestParameters: UpdateElsterContractStatusRequestParams, extraHttpRequestParams?: any): Observable<ElsterContractDTO>;

}
